const BioDataHead = {
    bio_head_tag: "Resume",
    bio_head_title: "A Summary of My Resume",

    bio_edu_sub_head: "My Education",
    bio_exp_sub_head: "My Experience",
    bio_skills_sub_head: "My Skills",

    bio_btn_1_text: "Downlaod CV",
    bio_btn_2_text: "Hire Me",
};

const BioDataEdu = [
    {
        id: 1,
        edu_course: "B.Tech in Electrical Engineering",
        edu_place: "JGEC / 2019 - Present",
        edu_desc:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    },
    {
        id: 2,
        edu_course: "Senior Secondary Examination, (12)",
        edu_place: "MDB DAV, Bankura / 2017 - 2019",
        edu_desc:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    },
    {
        id: 3,
        edu_course: "Secondary Examination, (10)",
        edu_place: "JNV, Purulia / 2013 - 2017",
        edu_desc:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    },
];

const BioDataExp = [
    {
        id: 1,
        exp_course: "Front End Developer",
        exp_place: "SAAC / 2021 - Current",
        exp_desc:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    },
    {
        id: 2,
        exp_course: "Web Team",
        exp_place: "GDSC JGEC / 2021 - Current",
        exp_desc:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    },
    {
        id: 3,
        exp_course: "UI/UX",
        exp_place: "Self Projects / 2019 - Current",
        exp_desc:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the dummy text.",
    },
];

const BioDataSkills = [
    {
        id: 1,
        skills_icon: "assets/icons/html.svg",
        skills_alt: "HTML",
    },
    {
        id: 2,
        skills_icon: "assets/icons/css.svg",
        skills_alt: "CSS",
    },
    {
        id: 3,
        skills_icon: "assets/icons/js.svg",
        skills_alt: "JS",
    },
    {
        id: 4,
        skills_icon: "assets/icons/react.svg",
        skills_alt: "React",
    },
    {
        id: 5,
        skills_icon: "assets/icons/jquery.svg",
        skills_alt: "Jquery",
    },
    {
        id: 6,
        skills_icon: "assets/icons/sass.svg",
        skills_alt: "Sass",
    },
    {
        id: 7,
        skills_icon: "assets/icons/nodejs.svg",
        skills_alt: "Node JS",
    },
    {
        id: 8,
        skills_icon: "assets/icons/php.svg",
        skills_alt: "PHP",
    },
    {
        id: 9,
        skills_icon: "assets/icons/mongodb.svg",
        skills_alt: "Mongo DB",
    },
    {
        id: 10,
        skills_icon: "assets/icons/git.svg",
        skills_alt: "Git",
    },
    {
        id: 11,
        skills_icon: "assets/icons/svg.svg",
        skills_alt: "SVG",
    },
];

export { BioDataHead, BioDataEdu, BioDataExp, BioDataSkills };
